import {GetFromParseBySlug, FindFromParse} from './parse';

export const IsObjectEmpty = (obj) => {
  for(var key in obj) {
      if(obj.hasOwnProperty(key))
          return false;
  }
  return true;
}

export const ShuffleArray = (a) => {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
  }
  return a;
}

export const GetUrlVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
          return pair[1];
      }
  }
  return (false);
}

export const GetUrlParamFromRoute = (route) => {
  let param = null;
  if(window.location.pathname.indexOf(route) != -1){
    let prefix = window.location.pathname.indexOf(route)+route.length
    param = window.location.pathname.slice(prefix,window.location.pathname.length)
  }
  return param;
}

export const GetCookieValue = (a) => {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

export const StripHtml = (html) =>{
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent.replace(/(\r\n|\n|\r)/gm, "") || tmp.innerText.replace(/(\r\n|\n|\r)/gm, "") || "";
}
